export const couponsAdapter = module => {
  return module
}
